import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "content",
  ref: "content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "scrollable-list",
    ref: "scrollableList",
    onMouseover: _cache[0] || (_cache[0] = (...args) => $options.stopScroll && $options.stopScroll(...args)),
    onMouseout: _cache[1] || (_cache[1] = (...args) => $options.startScroll && $options.startScroll(...args)),
    onScroll: _cache[2] || (_cache[2] = (...args) => $options.handleScroll && $options.handleScroll(...args))
  }, [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")], 512)], 544);
}